// TODO: redesign-dticket - make it reusable across Subscription Pause flow

import { Trans, useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { MplButton, MplModal } from '@mopla/ui';

interface IDTicketEditPauseInfoModalProps {
	open: boolean;
	onClose: () => void;
}

export const DTicketEditPauseInfoModal = ({
	open,
	onClose,
}: IDTicketEditPauseInfoModalProps) => {
	const { t } = useTranslation('dticketSubscriptionEditPause');

	const conditionsObj = t('info_modal.conditions', {
		returnObjects: true,
	}) as Record<string, string>;
	const conditions = Object.entries(conditionsObj);

	const modalContent = (
		<Box component="ol" sx={{ m: 0, pl: 2.5, textAlign: 'left' }}>
			{conditions.map(([key], index) => (
				<Typography
					key={key}
					component="li"
					variant="b2"
					color="primary.main"
					sx={{ mb: index < conditions.length - 1 ? 1 : 0 }}
				>
					<Trans
						i18nKey={`info_modal.conditions.${key}`}
						ns="dticketSubscriptionEditPause"
						components={{ b: <strong /> }}
					/>
				</Typography>
			))}
		</Box>
	);

	return (
		<MplModal
			open={open}
			testId="DTicketSubscriptionEditPause-PauseInfoModal"
			title={t('info_modal.title')}
			textAlign="left"
			content={modalContent}
			buttons={
				<MplButton
					variant="contained"
					color="primary"
					fullWidth
					onClick={onClose}
					testId="dticket-editPauseInfoModal-close-button"
				>
					{t('info_modal.button')}
				</MplButton>
			}
		/>
	);
};
